import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if (or this.loading this.canLoadMore)}}
  {{hide-application-footer}}
{{/if}}

<section class="user-content">
  <div class="group-members-actions">
    {{#if this.canManageGroup}}
      <DButton
        @icon="list"
        @action={{this.toggleBulkSelect}}
        @title="topics.bulk.toggle"
        class="bulk-select"
      />
    {{/if}}

    {{#if this.model.can_see_members}}
      <TextField
        @value={{this.filterInput}}
        @placeholderKey={{this.filterPlaceholder}}
        @autocomplete="off"
        class="group-username-filter no-blur"
      />
    {{/if}}

    {{#if this.canManageGroup}}
      {{#if this.isBulk}}
        <span class="bulk-select-buttons-wrap">
          {{#if this.bulkSelection}}
            <BulkGroupMemberDropdown
              @bulkSelection={{this.bulkSelection}}
              @canAdminGroup={{this.model.can_admin_group}}
              @canEditGroup={{this.model.can_edit_group}}
              @onChange={{action "actOnSelection" this.bulkSelection}}
            />

            <DButton
              @action={{this.bulkClearAll}}
              @label="topics.bulk.clear_all"
              @icon="far-square"
              class="bulk-select-clear"
            />
          {{/if}}

          <DButton
            @action={{this.bulkSelectAll}}
            @label="topics.bulk.select_all"
            @icon="check-square"
            class="bulk-select-all"
          />
        </span>
      {{/if}}

      <div class="group-members-manage">
        <DButton
          @icon="plus"
          @action={{route-action "showAddMembersModal"}}
          @label="groups.manage.add_members"
          class="btn-default group-members-add"
        />

        {{#if this.currentUser.can_invite_to_forum}}
          <DButton
            @icon="plus"
            @action={{route-action "showInviteModal"}}
            @label="groups.manage.invite_members"
            class="btn-default group-members-invite"
          />
        {{/if}}
      </div>
    {{/if}}
  </div>

  {{#if this.hasMembers}}
    <LoadMore
      @selector=".directory-table .directory-table__cell"
      @action={{action "loadMore"}}
    >
      <ResponsiveTable
        @className="group-members
          {{if this.isBulk 'sticky-header' ''}}
          {{if this.canManageGroup 'group-members--can-manage' ''}}"
      >
        <:header>
          <TableHeaderToggle
            @order={{this.order}}
            @asc={{this.asc}}
            @field="username_lower"
            @labelKey="username"
            @automatic={{true}}
            @colspan="2"
            class="directory-table__column-header--username username"
          />

          {{#if this.canManageGroup}}
            <div
              class="directory-table__column-header directory-table__column-header--can-manage"
            ></div>
          {{/if}}

          <PluginOutlet
            @name="group-index-table-header-after-username"
            @outletArgs={{hash group=this.model asc=this.asc order=this.order}}
          />

          <TableHeaderToggle
            @order={{this.order}}
            @asc={{this.asc}}
            @field="added_at"
            @labelKey="groups.member_added"
            @automatic={{true}}
            class="directory-table__column-header--added"
          />
          <TableHeaderToggle
            @order={{this.order}}
            @asc={{this.asc}}
            @field="last_posted_at"
            @labelKey="last_post"
            @automatic={{true}}
            class="directory-table__column-header--last-posted"
          />
          <TableHeaderToggle
            @order={{this.order}}
            @asc={{this.asc}}
            @field="last_seen_at"
            @labelKey="last_seen"
            @automatic={{true}}
            class="directory-table__column-header--last-seen"
          />

          {{#if this.canManageGroup}}
            <div
              class="directory-table__column-header directory-table__column-header--member-settings"
            ></div>
          {{/if}}
        </:header>

        <:body>
          {{#each this.model.members as |m|}}
            <div class="directory-table__row">
              <div
                class="directory-table__cell directory-table__cell--username group-member"
                colspan="2"
              >
                {{#if this.canManageGroup}}
                  {{#if this.isBulk}}
                    <Input
                      @type="checkbox"
                      class="bulk-select"
                      {{on "click" (action "selectMember" m)}}
                    />
                  {{/if}}
                {{/if}}
                <UserInfo
                  @user={{m}}
                  @skipName={{this.skipName}}
                  @showStatus={{true}}
                  @showStatusTooltip={{true}}
                />
              </div>

              {{#if this.canManageGroup}}
                <div
                  class="directory-table__cell directory-table__cell--can-manage group-owner"
                >
                  {{#if (or m.owner m.primary)}}
                    <span class="directory-table__label">
                      <span>{{i18n "groups.members.status"}}</span>
                    </span>
                  {{/if}}
                  <span class="directory-table__value">
                    {{#if m.owner}}
                      {{d-icon "shield-alt"}}
                      {{i18n "groups.members.owner"}}<br />
                    {{/if}}
                    {{#if m.primary}}
                      {{i18n "groups.members.primary"}}
                    {{/if}}
                  </span>

                </div>
              {{/if}}

              <PluginOutlet
                @name="group-index-table-row-after-username"
                @outletArgs={{hash member=m}}
              />

              <div class="directory-table__cell directory-table__cell--added">
                <span class="directory-table__label">
                  <span>{{i18n "groups.member_added"}}</span>
                </span>
                <span class="directory-table__value">
                  {{bound-date m.added_at}}
                </span>
              </div>
              <div
                class="directory-table__cell{{unless
                    m.last_posted_at
                    '--empty'
                  }}
                  directory-table__cell--last-posted"
              >
                {{#if m.last_posted_at}}
                  <span class="directory-table__label">
                    <span>{{i18n "last_post"}}</span>
                  </span>
                {{/if}}
                <span class="directory-table__value">
                  {{bound-date m.last_posted_at}}
                </span>
              </div>
              <div
                class="directory-table__cell{{unless m.last_seen_at '--empty'}}
                  directory-table__cell--last-seen"
              >
                {{#if m.last_seen_at}}
                  <span class="directory-table__label">
                    <span>{{i18n "last_seen"}}</span>
                  </span>
                {{/if}}
                <span class="directory-table__value">
                  {{bound-date m.last_seen_at}}
                </span>
              </div>
              {{#if this.canManageGroup}}
                <div
                  class="directory-table__cell directory-table__cell--member-settings member-settings"
                >
                  <GroupMemberDropdown
                    @member={{m}}
                    @canAdminGroup={{this.model.can_admin_group}}
                    @canEditGroup={{this.model.can_edit_group}}
                    @onChange={{action "actOnGroup" m}}
                  />
                  {{! group parameter is used by plugins }}
                </div>
              {{/if}}
            </div>
          {{/each}}
        </:body>
      </ResponsiveTable>
    </LoadMore>

    <ConditionalLoadingSpinner @condition={{this.loading}} />
  {{else}}
    <br />
    <div>{{i18n this.emptyMessageKey}}</div>
  {{/if}}
</section>
*/
{
  "id": "nuDNVygH",
  "block": "[[[41,[28,[37,1],[[30,0,[\"loading\"]],[30,0,[\"canLoadMore\"]]],null],[[[1,\"  \"],[1,[34,2]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,\"section\"],[14,0,\"user-content\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"group-members-actions\"],[12],[1,\"\\n\"],[41,[30,0,[\"canManageGroup\"]],[[[1,\"      \"],[8,[39,3],[[24,0,\"bulk-select\"]],[[\"@icon\",\"@action\",\"@title\"],[\"list\",[30,0,[\"toggleBulkSelect\"]],\"topics.bulk.toggle\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"model\",\"can_see_members\"]],[[[1,\"      \"],[8,[39,4],[[24,0,\"group-username-filter no-blur\"]],[[\"@value\",\"@placeholderKey\",\"@autocomplete\"],[[30,0,[\"filterInput\"]],[30,0,[\"filterPlaceholder\"]],\"off\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canManageGroup\"]],[[[41,[30,0,[\"isBulk\"]],[[[1,\"        \"],[10,1],[14,0,\"bulk-select-buttons-wrap\"],[12],[1,\"\\n\"],[41,[30,0,[\"bulkSelection\"]],[[[1,\"            \"],[8,[39,5],null,[[\"@bulkSelection\",\"@canAdminGroup\",\"@canEditGroup\",\"@onChange\"],[[30,0,[\"bulkSelection\"]],[30,0,[\"model\",\"can_admin_group\"]],[30,0,[\"model\",\"can_edit_group\"]],[28,[37,6],[[30,0],\"actOnSelection\",[30,0,[\"bulkSelection\"]]],null]]],null],[1,\"\\n\\n            \"],[8,[39,3],[[24,0,\"bulk-select-clear\"]],[[\"@action\",\"@label\",\"@icon\"],[[30,0,[\"bulkClearAll\"]],\"topics.bulk.clear_all\",\"far-square\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[8,[39,3],[[24,0,\"bulk-select-all\"]],[[\"@action\",\"@label\",\"@icon\"],[[30,0,[\"bulkSelectAll\"]],\"topics.bulk.select_all\",\"check-square\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"group-members-manage\"],[12],[1,\"\\n        \"],[8,[39,3],[[24,0,\"btn-default group-members-add\"]],[[\"@icon\",\"@action\",\"@label\"],[\"plus\",[28,[37,7],[\"showAddMembersModal\"],null],\"groups.manage.add_members\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"currentUser\",\"can_invite_to_forum\"]],[[[1,\"          \"],[8,[39,3],[[24,0,\"btn-default group-members-invite\"]],[[\"@icon\",\"@action\",\"@label\"],[\"plus\",[28,[37,7],[\"showInviteModal\"],null],\"groups.manage.invite_members\"]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"hasMembers\"]],[[[1,\"    \"],[8,[39,8],null,[[\"@selector\",\"@action\"],[\".directory-table .directory-table__cell\",[28,[37,6],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,9],null,[[\"@className\"],[[29,[\"group-members\\n          \",[52,[30,0,[\"isBulk\"]],\"sticky-header\",\"\"],\"\\n          \",[52,[30,0,[\"canManageGroup\"]],\"group-members--can-manage\",\"\"]]]]],[[\"header\",\"body\"],[[[[1,\"\\n          \"],[8,[39,10],[[24,0,\"directory-table__column-header--username username\"]],[[\"@order\",\"@asc\",\"@field\",\"@labelKey\",\"@automatic\",\"@colspan\"],[[30,0,[\"order\"]],[30,0,[\"asc\"]],\"username_lower\",\"username\",true,\"2\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"canManageGroup\"]],[[[1,\"            \"],[10,0],[14,0,\"directory-table__column-header directory-table__column-header--can-manage\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[8,[39,11],null,[[\"@name\",\"@outletArgs\"],[\"group-index-table-header-after-username\",[28,[37,12],null,[[\"group\",\"asc\",\"order\"],[[30,0,[\"model\"]],[30,0,[\"asc\"]],[30,0,[\"order\"]]]]]]],null],[1,\"\\n\\n          \"],[8,[39,10],[[24,0,\"directory-table__column-header--added\"]],[[\"@order\",\"@asc\",\"@field\",\"@labelKey\",\"@automatic\"],[[30,0,[\"order\"]],[30,0,[\"asc\"]],\"added_at\",\"groups.member_added\",true]],null],[1,\"\\n          \"],[8,[39,10],[[24,0,\"directory-table__column-header--last-posted\"]],[[\"@order\",\"@asc\",\"@field\",\"@labelKey\",\"@automatic\"],[[30,0,[\"order\"]],[30,0,[\"asc\"]],\"last_posted_at\",\"last_post\",true]],null],[1,\"\\n          \"],[8,[39,10],[[24,0,\"directory-table__column-header--last-seen\"]],[[\"@order\",\"@asc\",\"@field\",\"@labelKey\",\"@automatic\"],[[30,0,[\"order\"]],[30,0,[\"asc\"]],\"last_seen_at\",\"last_seen\",true]],null],[1,\"\\n\\n\"],[41,[30,0,[\"canManageGroup\"]],[[[1,\"            \"],[10,0],[14,0,\"directory-table__column-header directory-table__column-header--member-settings\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"        \"]],[]],[[[1,\"\\n\"],[42,[28,[37,14],[[28,[37,14],[[30,0,[\"model\",\"members\"]]],null]],null],null,[[[1,\"            \"],[10,0],[14,0,\"directory-table__row\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"directory-table__cell directory-table__cell--username group-member\"],[14,\"colspan\",\"2\"],[12],[1,\"\\n\"],[41,[30,0,[\"canManageGroup\"]],[[[41,[30,0,[\"isBulk\"]],[[[1,\"                    \"],[8,[39,15],[[24,0,\"bulk-select\"],[4,[38,16],[\"click\",[28,[37,6],[[30,0],\"selectMember\",[30,1]],null]],null]],[[\"@type\"],[\"checkbox\"]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"                \"],[8,[39,17],null,[[\"@user\",\"@skipName\",\"@showStatus\",\"@showStatusTooltip\"],[[30,1],[30,0,[\"skipName\"]],true,true]],null],[1,\"\\n              \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canManageGroup\"]],[[[1,\"                \"],[10,0],[14,0,\"directory-table__cell directory-table__cell--can-manage group-owner\"],[12],[1,\"\\n\"],[41,[28,[37,1],[[30,1,[\"owner\"]],[30,1,[\"primary\"]]],null],[[[1,\"                    \"],[10,1],[14,0,\"directory-table__label\"],[12],[1,\"\\n                      \"],[10,1],[12],[1,[28,[35,18],[\"groups.members.status\"],null]],[13],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null],[1,\"                  \"],[10,1],[14,0,\"directory-table__value\"],[12],[1,\"\\n\"],[41,[30,1,[\"owner\"]],[[[1,\"                      \"],[1,[28,[35,19],[\"shield-alt\"],null]],[1,\"\\n                      \"],[1,[28,[35,18],[\"groups.members.owner\"],null]],[10,\"br\"],[12],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"primary\"]],[[[1,\"                      \"],[1,[28,[35,18],[\"groups.members.primary\"],null]],[1,\"\\n\"]],[]],null],[1,\"                  \"],[13],[1,\"\\n\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n              \"],[8,[39,11],null,[[\"@name\",\"@outletArgs\"],[\"group-index-table-row-after-username\",[28,[37,12],null,[[\"member\"],[[30,1]]]]]],null],[1,\"\\n\\n              \"],[10,0],[14,0,\"directory-table__cell directory-table__cell--added\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"directory-table__label\"],[12],[1,\"\\n                  \"],[10,1],[12],[1,[28,[35,18],[\"groups.member_added\"],null]],[13],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,1],[14,0,\"directory-table__value\"],[12],[1,\"\\n                  \"],[1,[28,[35,20],[[30,1,[\"added_at\"]]],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[15,0,[29,[\"directory-table__cell\",[52,[51,[30,1,[\"last_posted_at\"]]],\"--empty\"],\"\\n                  directory-table__cell--last-posted\"]]],[12],[1,\"\\n\"],[41,[30,1,[\"last_posted_at\"]],[[[1,\"                  \"],[10,1],[14,0,\"directory-table__label\"],[12],[1,\"\\n                    \"],[10,1],[12],[1,[28,[35,18],[\"last_post\"],null]],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[10,1],[14,0,\"directory-table__value\"],[12],[1,\"\\n                  \"],[1,[28,[35,20],[[30,1,[\"last_posted_at\"]]],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[15,0,[29,[\"directory-table__cell\",[52,[51,[30,1,[\"last_seen_at\"]]],\"--empty\"],\"\\n                  directory-table__cell--last-seen\"]]],[12],[1,\"\\n\"],[41,[30,1,[\"last_seen_at\"]],[[[1,\"                  \"],[10,1],[14,0,\"directory-table__label\"],[12],[1,\"\\n                    \"],[10,1],[12],[1,[28,[35,18],[\"last_seen\"],null]],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[10,1],[14,0,\"directory-table__value\"],[12],[1,\"\\n                  \"],[1,[28,[35,20],[[30,1,[\"last_seen_at\"]]],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"],[41,[30,0,[\"canManageGroup\"]],[[[1,\"                \"],[10,0],[14,0,\"directory-table__cell directory-table__cell--member-settings member-settings\"],[12],[1,\"\\n                  \"],[8,[39,22],null,[[\"@member\",\"@canAdminGroup\",\"@canEditGroup\",\"@onChange\"],[[30,1],[30,0,[\"model\",\"can_admin_group\"]],[30,0,[\"model\",\"can_edit_group\"]],[28,[37,6],[[30,0],\"actOnGroup\",[30,1]],null]]],null],[1,\"\\n\"],[1,\"                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"]],[1]],null],[1,\"        \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,23],null,[[\"@condition\"],[[30,0,[\"loading\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,\"br\"],[12],[13],[1,\"\\n    \"],[10,0],[12],[1,[28,[35,18],[[30,0,[\"emptyMessageKey\"]]],null]],[13],[1,\"\\n\"]],[]]],[13]],[\"m\"],false,[\"if\",\"or\",\"hide-application-footer\",\"d-button\",\"text-field\",\"bulk-group-member-dropdown\",\"action\",\"route-action\",\"load-more\",\"responsive-table\",\"table-header-toggle\",\"plugin-outlet\",\"hash\",\"each\",\"-track-array\",\"input\",\"on\",\"user-info\",\"i18n\",\"d-icon\",\"bound-date\",\"unless\",\"group-member-dropdown\",\"conditional-loading-spinner\"]]",
  "moduleName": "discourse/templates/group-index.hbs",
  "isStrictMode": false
});